<template>
  <a-modal
    ref="planTable"
    title="发放选项："
    :width="800"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirm"
  >

    <!-- <div class="table-page-operator-wrapper">
      <a-button @click="addLine()" type="primary">新增行</a-button>
    </div> -->
    <template slot="footer">
      <a-button @click="close" key="back">
        取消
      </a-button>
      <a-button @click="confirm" key="submit" type="primary" :loading="confirmLoading">
        发放选中记录
      </a-button>
      <a-button @click="confirmAll" key="submit" type="primary" :loading="confirmLoading">
        发放全部记录
      </a-button>
    </template>
    <a-spin :spinning="isLoading">

      <a-table
        style="heigh:300"
        ref="modalTable"
        :columns="columns"
        :scroll="{ fixScreen: false,y: 300}"
        :data-source="typeList"
        :pagination="false"
        row-key="indexId"
      >
        <template slot="insideOutside" slot-scope="text, record">
          <span >{{ record.insideOutside?(record.insideOutside==='I'?'内部':'外部'):'' }}</span>
        </template>
      </a-table>
    </a-spin>
  </a-modal>
</template>

<script>
import { apiStartCalculate } from '@/api/scp/shipmentForecast/shipmentForecastManagement'
import { ApiListLockRulesForPlanSheet } from '@/api/mps/basic-data/mps-option.js'
import { apiPublishPlanSheet } from '@/api/mps/basic-data/mps-plan-execution.js'
// 表单字段
export default {
  props: {
    selectRows: {
      type: Array,
      default: () => {
        return []
      }
    },
    workshopTypeList: {
      type: Array,
      default: () => {
        return []
      }
    },
    queryParams: {
      type: Object, // 将类型更改为对象
      default: () => {
        return {} // 默认值改为空对象
      }
    }
  },
  data () {
    return {
      isLoading: false,
      labelCol: { span: 5 },
      wrapperCol: { span: 14 },
      value: 1,
      timeActionType: 1,
      runIntervalTime: '', // 运行间隔时间
      runningTime: '',
      startingTime: '',
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      workshopMcNameList: [], // 车间物控(缺接口数据)
      defaultJobClassList: [],
      ruleForm: {
        mpsMonthNameVersion: '',
        mpsParamVersion: '',
        mpsPlanVersion: '',
        startDate: ''
      },
      rules: {
        mpsMonthNameVersion: [{ required: true, message: '请输入计划版本', trigger: 'change' }],
        mpsParamVersion: [{ required: true, message: '请输入计划版本', trigger: 'change' }],
        mpsPlanVersion: [{ required: true, message: '请输入计划版本', trigger: 'change' }],
        startDate: [{ required: true, message: '请输入计划版本', trigger: 'change' }]
      },
                  // 表格字段
     typeList: [],
      unitOfMeasureList: [],
      // 表格字段
      columns: [
        {
          title: '内外部',
          dataIndex: 'insideOutside',
          scopedSlots: { customRender: 'insideOutside' },
          align: 'center',
          width: 120
        },
        {
          title: '天数起',
          dataIndex: 'dayFrom',
          width: 120,
          align: 'center'
        },
        {
          title: '天数止',
          dataIndex: 'dayTo',
          width: 120,
          align: 'center'
        },
        {
          title: '发放单据类型',
          dataIndex: 'orderType',
          width: 160,
          align: 'center'
        }
      ]
    }
  },
  created () {},
  methods: {
    loadPageData () {
      this.isLoading = true
      ApiListLockRulesForPlanSheet().then((response) => {
        this.isLoading = false
        if (response.code === 200) {
          this.typeList = response.data
        } else {
          this.$message.error(response.msg)
        }
      }).catch((e) => { this.isLoading = false })
    },
    handleQuery () {
      apiStartCalculate().then((response) => {
        if (response.code === 200) {
          this.$message.success('删除成功')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    show () {
      this.visible = true
    //  this.addPlanCode()
      this.loadPageData()
    },
    // 关闭模态框
    close () {
      this.visible = false
    },
    confirmAll () {
      if (!this.queryParams.version) {
        this.$message.error('请先选择版本')
        return
      }
      this.confirmSever({ ...this.queryParams })
    },
    confirm () {
      if (this.selectRows.length === 0) {
        this.$message.error('请选中发放项')
        return
      }
      this.confirmSever({ ids: this.selectRows, version: this.queryParams.version })
    },
    confirmSever (params) {
      const self = this
       self.confirmLoading = true
       apiPublishPlanSheet(params).then((response) => {
        self.confirmLoading = false
        if (response.code === 200) {
          self.$message.success('发放成功')
                // 关闭本组件
                self.visible = false
                // 调用外部刷新列表方法
                self.$emit('handle-success')
                // 刷新表单
             //   this.reset()
              } else {
                self.$message.error(response.msg)
              }
          }).catch(function () {
            self.confirmLoading = false
          })
        }

    }
  }

</script>

<style scoped lang="less">

  /deep/.ant-select{
    width: 100% !important;
  }
.title{
    font-weight: 650;
    font-style: normal;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.847);
    line-height: 24px;
    border-width: 0px;
}.item{
  margin: 20px 0 20px 60px;
}
</style>
